export default __webpack_public_path__ + "static/media/img.ba43941a.jpg";